import remove from 'lodash/remove';
import React from 'react';

import { PersonOrgType } from '@ndvr/auth-api';

import { getClientTypeAlias, getDateRangeLabel } from 'utils';
import { FilterLabel, FilterStateLabels, HorizontalLayout } from 'widgets';

import { ClientFilterKeys, useClientFiltersContext } from './ClientFiltersContext';

export const ClientFilterLabels = () => {
    return (
        <HorizontalLayout $gap={8} $wrapContent>
            <PersonOrgTypeLabels />
            <StartDateLabels />
            <StateLabels />
        </HorizontalLayout>
    );
};

const PersonOrgTypeLabels = () => {
    const { filters, patchFilters } = useClientFiltersContext();

    const removePersonOrgType = (personOrgType: PersonOrgType) =>
        patchFilters({
            [ClientFilterKeys.personOrgTypes]: remove(filters.personOrgTypes, (type) => personOrgType !== type),
        });

    return (
        <>
            {filters.personOrgTypes.map((personOrgType) => (
                <FilterLabel
                    key={personOrgType}
                    label={getClientTypeAlias(personOrgType)}
                    onRemove={() => removePersonOrgType(personOrgType)}
                />
            ))}
        </>
    );
};

const StartDateLabels = () => {
    const { filters, resetFilters, isStartDateFilterActive } = useClientFiltersContext();

    return isStartDateFilterActive ? (
        <FilterLabel
            label={getDateRangeLabel('Start Date', filters.startDateStart, filters.startDateEnd)}
            onRemove={() => resetFilters([ClientFilterKeys.startDateStart, ClientFilterKeys.startDateEnd])}
        />
    ) : null;
};

const StateLabels = () => {
    const { filters, patchFilters } = useClientFiltersContext();

    const removeState = (stateAbbriviation: string) =>
        patchFilters({
            [ClientFilterKeys.states]: remove(filters.states, (state) => stateAbbriviation !== state),
        });

    return <FilterStateLabels stateAbbriviations={filters.states} onRemove={removeState} />;
};
